import { createApiSlice } from "@common";
import {
    CURD_INQUIRY_DISPOSITION
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addInquiryDisposition",
        method: "post",
        url: CURD_INQUIRY_DISPOSITION,
        stateKey: "message",
    },
    {
        name: "getInquiryDisposition",
        method: "get",
        url: CURD_INQUIRY_DISPOSITION,
        stateKey: "data",
    },
    {
        name: "updateInquiryDisposition",
        method: "put",
        url: CURD_INQUIRY_DISPOSITION,
        stateKey: "message",
    },
    {
        name: "deleteInquiryDisposition",
        method: "delete",
        url: CURD_INQUIRY_DISPOSITION,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "inquiryDisposition",
    apiConfig,
    customReducers,
);
const inquiryDispositionSlice = slice;
// Export the slice's reducer
export default inquiryDispositionSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addInquiryDisposition,
    getInquiryDisposition,
    updateInquiryDisposition,
    deleteInquiryDisposition
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
